import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Label, Row} from 'reactstrap';
import {connect} from 'react-redux'

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    error,
    LIST,
    NO,
    YES,
} from "../../../components/i18n/i18n";

import {
    remove as removePoint,
    save as savePoint,
    search as searchPoint,
    update as updatePoint
} from "../../../redux/actions/xeeker/pointActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {setItems, setModal} from "../../../redux/actions/generalActions/subFormActions";
import {saveMap, calculatePath} from "../../../redux/actions/xeeker/pathActions";
import {remove as removeVector} from "../../../redux/actions/xeeker/vectorActions";

import {GraphView} from "react-digraph";
import {
    default as otherConfig,
    NODE_KEY,
    SPECIAL_EDGE_TYPE,
} from "./config";

import {
    default as nodeConfig,
} from "./nodeConfig"

import {TT_DELETE, TT_EDIT, TT_FIND_PATH, TT_NODE_ADD, TT_SEARCH} from "../../../components/i18n/toolTips";
import {
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {pointService} from "../../../jwt/_services/xeeker/pointService";
import {vectorService} from "../../../jwt/_services/xeeker/vectorService";
import {useForm} from "react-hook-form";
import {confirmAlert} from "react-confirm-alert";
import PointInpunt from "./pointInpunt";
import VectorInput from "./vectorInput";
import {showToastCustom} from "../../../components/toast/customToast";
import {pathService} from "../../../jwt/_services/xeeker/pathService";
import PathFilters from "./_filters";

const PathCanvas = props => {

    const { app, udn } = props.mainProps

    const [nodes, setNodes] = useState(  []);
    const [dbNodes, setDbNodes] = useState(  []);
    const [selectedNode, setSelectedNode] = useState({});
    const [selectedPrevNode, setSelectedPrevNode] = useState({});

    const [edges, setEdges] = useState([]);
    const [dbEdges, setDbEdges] = useState([]);
    const [selectedEdge, setSelectedEdge] = useState({});

    const refGraphView = useRef(null);

    const { handleSubmit } = useForm({
    });

    const onSubmit = (data, _) => {
        const _nodesToSave = mapNodesToDbNodes(nodes, dbNodes)
        const _edgesToSave = mapEdgesToDbEdges(edges, dbEdges)

        const _fbDataBaseId = app?.fbDataBase?.id
        const dataRequest = {
            fbDataBase : { id : _fbDataBaseId },
            item : {
                nodes : _nodesToSave,
                edges : _edgesToSave,
            }
        }

        props.saveMap(dataRequest);
    };

    const mapNodesToDbNodes = ( _nodes, _dbNodes ) => {
        return _nodes.map((_node) => {
            // Si lo encuentra, hace match con los datos, si no, genera un nuevo nodo en DbNodes
            const nodeIndex = _dbNodes.findIndex(n => n.id === _node.id);

            if (nodeIndex === -1) {
                return {
                    id: _node.id,
                    code: _node.title,
                    type: _node.type,
                    x: _node.x,
                    y: _node.y,
                    status : _node.status,
                    interest : _node.interest,
                    place : _node.place,
                    udn: { id : udn.id },
                }
            } else {
                return {
                    id : _dbNodes[nodeIndex].id,
                    code: _node.title,
                    type: _node.type,
                    x: _node.x,
                    y: _node.y,
                    status : _dbNodes[nodeIndex].status,
                    interest : _dbNodes[nodeIndex].interest,
                    place : _dbNodes[nodeIndex].place,
                    udn: { id : udn.id },
                }
            }
        });
    };

    const mapEdgesToDbEdges = ( _edges, _dbEdges ) => {
        return _edges.map((_edge) => {
            // Si lo encuentra, hace match con los datos, si no, genera un nuevo nodo en DbNodes
            const edgeIndex = _dbEdges.findIndex(n => n.source === _edge.source && n.target === _edge.target );
            const sourceIndex = nodes.findIndex(n => n.id === _edge.source);
            const targetIndex = nodes.findIndex(n => n.id === _edge.target);

            if (edgeIndex === -1) {
                return {
                    id: null,
                    weight : _edge.handleText,
                    langs : _edge.langs,
                    pointA : { id : nodes[sourceIndex].title },
                    pointB : { id : nodes[targetIndex].title },
                    udn: { id : udn.id },
                }
            } else {
                return {
                    id : _dbEdges[edgeIndex].id,
                    weight : _edge.handleText,
                    langs : _edge.langs,
                    icon : _dbEdges[edgeIndex].icon,
                    invertedIcon : _dbEdges[edgeIndex].invertedIcon,
                    pointA : { id : nodes[sourceIndex].title },
                    pointB : { id : nodes[targetIndex].title },
                    udn: { id : udn.id },
                }
            }
        });
    };

    // Search nodos y vectores
    const refreshFiltered = (_dataFilter) => {
        refreshNodes(_dataFilter);
    }

    const refreshNodes = (_dataFilter) => {
        props.setLoading(true);
        pointService.search(0, 1000, _dataFilter)
            .then(result => {
                if (result){
                    setNodes(mapResultToNodes(result.data));
                    setDbNodes(result.data);
                } else {
                    setNodes([]);
                }
                vectorService.search(0, 1000, _dataFilter)
                    .then(result => {
                        if (result){
                            setEdges(mapResultToEdges(result.data));
                            setDbEdges(result.data);
                        } else {
                            setNodes([]);
                        }
                        props.setLoading(false);
                    })
                    .catch(ex => {
                        props.setLoading(false);
                        console.log(ex)
                    });
            })
            .catch(ex => {
                props.setLoading(false);
                console.log(ex)
            });
    }

    const mapResultToNodes = ( _nodes ) => {
        return _nodes.map((node) => {
            return {
                id: node.id,
                title: node.code,
                type: node.type,
                status : node.status,
                interest : node.interest,
                place : node.place,
                x: node.x,
                y: node.y,
            }
        });
    };

    const mapResultToEdges = ( _edges ) => {
        return _edges.map((edge) => {
            return {
                handleText: edge.handleText,
                source: edge.source,
                target: edge.target,
                langs: edge.langs,
                type: SPECIAL_EDGE_TYPE
            }
        });
    };

    const onSelect = (viewNode, event) => {
        if (event){
            const { id = "" } = event.target;
            if (id.includes("text")) {
                document.getElementById(event.target.id).click();
            }

            if (viewNode?.nodes) {
                setSelectedEdge({} );
                setSelectedPrevNode(selectedNode);
                let selection = viewNode.nodes.entries().next().value[1];
                const nodeIndex = dbNodes.findIndex(n => n.code === selection.title );
                selection.place = dbNodes[nodeIndex]?.place
                selection.status = dbNodes[nodeIndex]?.status
                selection.interest = dbNodes[nodeIndex]?.interest

                setSelectedNode( selection );
                props.setItem(selection);
            }
        }

        if (viewNode?.edges) {
            setSelectedNode( {} );
            let selection = viewNode.edges.entries().next().value[1];
            const edgeIndex = dbEdges.findIndex(n => n.source === selection.source && n.target === selection.target );
            selection.langs = dbEdges[edgeIndex]?.langs
            selection.icon = dbEdges[edgeIndex]?.icon
            selection.invertedIcon = dbEdges[edgeIndex]?.invertedIcon
            setSelectedEdge( selection );
        }
    };

    // -------------------------------
    // --         NODO              --
    // -------------------------------
    const confirmAddEditNode = (selectedNode) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <PointInpunt
                addNode={addNode}
                onClose={onClose}
                onEditNode={onEditNode}
                selectedNode={selectedNode}
            />
    });

    const addNode = ( data, type, status, interest, place) => {
        const id =  Date.now();
        setNodes([
            {
                id : id,
                title : data,
                type : type,
                x : 100,
                y : 100,
                status : status,
                interest : interest,
                place : place,
            },
            ...nodes
        ]);

        setDbNodes([
            {
                id : id,
                title : data,
                type : type,
                x : 100,
                y : 100,
                status : status,
                interest : interest,
                place : place,
            },
            ...dbNodes
        ]);
    };

    const onEditNode = ( _node ) => {
        if (_node) {
            const nodeIndex = nodes.findIndex(n => n.id === _node.id);
            let _nodes = nodes.slice()
            _nodes[nodeIndex].title = _node.title;
            _nodes[nodeIndex].status = _node.status;
            _nodes[nodeIndex].interest = _node.interest;
            _nodes[nodeIndex].place = _node.place;

            setNodes(_nodes);
        }
    };

    const confirmDeleteNode = () => {
        const nodeIndex = dbNodes.findIndex(n => n.code === selectedNode.title );
        const _node = dbNodes[nodeIndex]

        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.removePoint(_node.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    }

    // -------------------------------
    // --         VECT              --
    // -------------------------------
    const confirmAddEditEdge = (sourceViewNode, targetViewNode) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <VectorInput
                sourceViewNode={sourceViewNode}
                targetViewNode={targetViewNode}
                onClose={onClose}
                onNewEdge={onNewEdge}
                onEditEdge={onEditEdge}
                selectedEdge={selectedEdge}
            />
    });

    const onNewEdge = (sourceViewNode, targetViewNode, weight, langs) => {
        if (sourceViewNode[NODE_KEY] !== targetViewNode[NODE_KEY]) {
            setEdges([
                {
                    source: sourceViewNode[NODE_KEY],
                    target: targetViewNode[NODE_KEY],
                    handleText : weight,
                    langs : langs,
                    type : SPECIAL_EDGE_TYPE
                },
                ...edges
            ]);

            setDbEdges([
                {
                    source: sourceViewNode[NODE_KEY],
                    target: targetViewNode[NODE_KEY],
                    handleText : weight,
                    langs : langs,
                    type : SPECIAL_EDGE_TYPE
                },
                ...dbEdges
            ]);
        }
    };

    const onEditEdge = ( _edge ) => {
        if (_edge) {
            const edgeIndex = edges.findIndex(n => n.source === _edge.source && n.target === _edge.target );
            let _edges = edges.slice()
            _edges[edgeIndex].handleText = _edge.handleText;
            _edges[edgeIndex].langs = _edge.langs;
            _edges[edgeIndex].icon = _edge.icon;
            _edges[edgeIndex].invertedIcon = _edge.invertedIcon;

            setEdges(_edges);

            const dbEdgeIndex = dbEdges.findIndex(n => n.source === selectedEdge.source && n.target === selectedEdge.target );
            let _dbEdges = dbEdges.slice()
            _dbEdges[dbEdgeIndex].handleText = _edge.handleText;
            _dbEdges[dbEdgeIndex].langs = _edge.langs;
            _dbEdges[dbEdgeIndex].icon = _edge.icon;
            _dbEdges[dbEdgeIndex].invertedIcon = _edge.invertedIcon;
            setDbEdges(_dbEdges);
        }
    };

    const confirmDeleteEdge = () => {
        const edgeIndex = dbEdges.findIndex(n => n.source === selectedEdge.source && n.target === selectedEdge.target );
        const _edge = dbEdges[edgeIndex]

        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.removeVector(_edge.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    }

    // ---------------------------------
    // --         OBJECT              --
    // ---------------------------------
    const confirmDeleteObject = () => {
        if (selectedNode.title !== undefined) {
            // editNode
            confirmDeleteNode();
        }

        if (selectedEdge.source !== undefined ) {
            // editEdge
            confirmDeleteEdge();
        }
    }

    const confirmEditObject = () => {
        if (selectedNode.title !== undefined) {
            // editNode
            confirmAddEditNode(selectedNode);
        }

        if (selectedEdge.source !== undefined ) {
            // editEdge
            confirmAddEditEdge(null, null, selectedEdge);
        }
    }

    const calculatePath = () => {
        if (selectedNode.title === undefined) {
            showToastCustom(error, 'Debe seleccionar nodo B', true);
            return;
        }

        if (selectedPrevNode.title === undefined) {
            showToastCustom(error, 'Debe seleccionar nodo A', true);
            return;
        }

        const _fbDataBaseId = app?.fbDataBase?.id
        const dataRequest = {

            fbDataBase : { id : _fbDataBaseId },
            item : {  // Objeto Path
                pointA : { id : selectedPrevNode.id },
                pointB : { id : selectedNode.id },
                udn : udn
            }
        }

        props.setLoading(true);
        pathService.calculatePath(dataRequest)
            .then( (result) => {
                setNodes(mapResultToNodes(result.points));
                setDbNodes(result.points);

                setEdges(mapResultToEdges(result.vectors));
                setDbEdges(result.vectors);
                props.setLoading(false);
            })
            .catch((_) => {
                props.setLoading(false);
                showToastCustom(error, 'Error al calcular el camino', true);
            });

    }

    const onSelectNode = () => console.log('Not implemented onSelectNode')
    const onCreateNode = () => console.log('Not implemented onCreateNode')
    const onUpdateNode = () => console.log('Not implemented onUpdateNode')
    const onDeleteNode = () => console.log('Not implemented onDeleteNode')
    const onSelectEdge = () => console.log('Not implemented onSelectEdge')
    const onSwapEdge = () => console.log('Not implemented onSwapEdge')
    const onDeleteEdge = () => console.log('Not implemented onDeleteEdge')

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
                <div className="float-right">
                    <GenericTableButton toolTip={TT_SEARCH} icon={'fa-sync'} permission={'edit'} onClick={refreshNodes}/>
                    <GenericTableButton toolTip={TT_FIND_PATH} icon={'fa-code-branch'} permission={'edit'} onClick={calculatePath}/>
                    <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={confirmDeleteObject}/>
                    <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={confirmEditObject}/>
                    <GenericTableButton toolTip={TT_NODE_ADD} icon={'fa-plus'} permission={'edit'} onClick={confirmAddEditNode}/>
                </div>
            </CardTitle>


            <PathFilters refreshFiltered={refreshFiltered} />

            <Form onSubmit={handleSubmit(onSubmit)}>
                <CardBody className="map_canvas" >
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Nodo A'}</Label>
                                <br/>
                                { selectedPrevNode.title !== undefined ? <label> { 'Nodo previo: ' + selectedPrevNode.title } </label> : null }
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{'Conexion'}</Label>
                                <br/>
                                { selectedEdge.source !== undefined ? <label> { 'Conexion de ' + selectedEdge.source + ' a ' + selectedEdge.target } </label> : null }
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Nodo B'}</Label>
                                <br/>
                                { selectedNode.title !== undefined ? <label> { 'Nodo : ' + selectedNode.title } </label> : null }
                            </FormGroup>
                        </Col>
                    </Row>
                    <GraphView
                        showGraphControls={true}
                        gridSize="100rem"
                        gridDotSize={1}
                        renderNodeText={false}
                        ref={refGraphView}
                        nodeKey={NODE_KEY}
                        nodes={nodes}
                        edges={edges}
                        selected={selectedNode}
                        nodeTypes={nodeConfig.NodeTypes}
                        nodeSubtypes={otherConfig.NodeSubtypes}
                        edgeTypes={otherConfig.NodeTypes}
                        readOnly={false}
                        allowMultiselect={false}
                        onSelect={onSelect}
                        onCreateEdge={confirmAddEditEdge}

                        onSelectNode={onSelectNode}
                        onCreateNode={onCreateNode}
                        onUpdateNode={onUpdateNode}
                        onDeleteNode={onDeleteNode}
                        onSelectEdge={onSelectEdge}
                        onSwapEdge={onSwapEdge}
                        onDeleteEdge={onDeleteEdge}
                    />
                </CardBody>
                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonSubmit />
                    </div>
                </CardBody>
            </Form>
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    subFormProps : state.subFormProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    savePoint,
    updatePoint,
    removePoint,
    searchPoint,
    saveMap,
    calculatePath,
    removeVector,
    setItems,
    setModal,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PathCanvas)